<template>
    <div class="aboutUs" :style="{ minHeight: height + 'px' }">
        <div class="title">
            <span  v-for="(item,index) in data" :key="index" :class="{ active:acinx==index }" @click="getDetail(item,index)">{{ item.contentTitle }}</span>
        </div>  
        <div class="content" v-html="details"></div>  
    </div>    
</template>
<script>
export default {
    data(){
        return{
            data:'',
            height:'',
            acinx:0,
            details:''
        }
    },
    created(){
        this.height = document.body.clientHeight - 85;
        this.$https.get('/portal/content/getContentByCategory',{params:{id:'26'}}).then(res=>{
           if(res.code == 200){
               this.data = res.rows;
               this.details = res.rows[0].content;
           }
        })
    },
    mounted(){
        this.$parent.current = '9';
    },
    methods:{
        getDetail(item,index){
            this.acinx = index;
            this.details = item.content;
        }
    }
}
</script>

<style lang="less" scoped>
    .aboutUs{
        width: 1300px;
        margin: 0 auto;
        background: #fff;
        display: flex;
        .title{
            width: 200px;
            display: flex;
            flex-direction: column;
            margin-top:30px;
            text-align: center;
            line-height: 40px;
            span{
                cursor: pointer;
            }
            .active{
                color:red;
            }
        }
        .content{
            width: 1000px;
            margin-top:30px;
        }
    }
</style>